import EventDispatcher from "js-class.event-dispatcher";

import icon_trash from 'bundle-text:../assets/trash-solid.svg';
import icon_native from 'bundle-text:../assets/film-solid.svg';
import icon_vimeo from 'bundle-text:../assets/vimeo.svg';
import icon_youtube from 'bundle-text:../assets/youtube.svg';
import icon_hapidam from 'bundle-text:../assets/crop-simple-solid.svg';
import icon_gumlet from 'bundle-text:../assets/gumlet.svg';

export default class Source {
	constructor(param) {
		this.events = new EventDispatcher(this);
		this.param = param || {};
		this.dom = null
		this.dom__init();
	}

	on(eventName, callback) { this.events.registerEvent(eventName, callback); }
	off(eventName, callback) { this.events.unregisterEvent(eventName, callback); }
	fire(eventName, data) { this.events.fireEvent(eventName, data); }

	setHapidam(hapidam) {
		this.hapidam = hapidam;

		this.hapidam.on('select', result => {
			this.hapidam.close()
			if (result.type == "video") {
				if (result.provider == 'vimeo') {
					this.param.hapidam = true;
					this.param.loop = this.param.loop !== false;
					this.param.provider = result.provider;
					this.param.embed_id = result.embedId;
				}
				else if (result.provider == 'hapidam') {

					this.param.hapidam = true;
					this.param.loop = this.param.loop !== false;
					this.param.provider = 'native';
					this.param.embed_id = result?.display?.original;
				}
				this.dom__refresh();
				this.fire('change')
			}
		});
		this.dom__refresh();
	}

	getParam(k = null) {
		if (typeof k === 'string')
			return this.param[k];
		return { ...this.param };
	}
	setParam(k, v = null) {
		this.param[k] = v;
		this.dom__refresh();
		this.fire('change')
	}
	loadParam(param) {
		this.param = param;
		this.dom__refresh();
	}

	dom__init() {
		this.dom = document.createElement('div')
		this.dom.appendChild(this.dom__btn('youtube', icon_youtube, this.__askForUrlOrId));
		this.dom.appendChild(this.dom__btn('vimeo', icon_vimeo, this.__askForUrlOrId));
		this.dom.appendChild(this.dom__btn('native', icon_native, this.__askForUrl));
		this.dom.appendChild(this.dom__btn('hapidam', icon_hapidam, this.__hapidamOpen));
		this.dom.appendChild(this.dom__btn('gumlet', icon_gumlet, this.__askForUrlOrId));
		this.dom.appendChild(this.dom__btn('reset', icon_trash, this.__reset));

		this.dom_embed_id = document.createElement('input')
		this.dom_embed_id.setAttribute('readonly', true)
		this.dom.appendChild(this.dom_embed_id)
	}

	dom__btn(provider, icon, callback) {
		const el = document.createElement('button')
		el.setAttribute('type', 'button');
		el.setAttribute('data-provider', provider);
		el.innerHTML = icon || provider;
		el.addEventListener('click', callback.bind(this, provider))
		return el;
	}

	dom__refresh() {
		clearTimeout(this.dom__refresh_delay);
		this.dom__refresh_delay = setTimeout(this.dom__refresh_delayed.bind(this), 10);
	}

	dom__refresh_delayed() {
		this.dom.querySelectorAll('button').forEach(el => el.classList.remove('on'));
		if (!this.param.hapidam) {
			let selected = this.dom.querySelector(`button[data-provider="${this.param.provider}"]`)
			if (selected) {
				selected.classList.add('on');
			}
		}
		else {
			this.dom.querySelector('button[data-provider="hapidam"]').classList.add('on');
		}

		if (this.hapidam)
			this.dom.querySelector('button[data-provider="hapidam"]').style.display = "";
		else
			this.dom.querySelector('button[data-provider="hapidam"]').style.display = "none";

		this.dom_embed_id.value = this.param.provider + ':' + this.param.embed_id;
	}

	__reset(expectedProvider) {
		if (confirm('Do you really want to remove these settings?')) {
			this.param = {};
			this.dom__refresh();
			this.fire('change')
		}
	}

	__hapidamOpen() {
		this.hapidam.open();
	}

	async __askForUrl(provider) {
		var url = prompt('Video full URL (WebM, Ogg, or MP4');
		if (url === null)
			return;

		this.param.hapidam = false;
		this.param.loop = this.param.loop !== false;
		this.param.provider = provider;
		this.param.embed_id = url;
		this.dom__refresh();
		this.fire('change')
	}

	async __askForUrlOrId(expectedProvider) {
		var url = prompt('Video ID or full URL');
		if (url === null)
			return;

		var param = await this.__extractParametersFromUrl(url, expectedProvider);
		if (param) {
			this.param.hapidam = false;
			this.param.loop = this.param.loop !== false;
			this.param.provider = param.provider;
			this.param.embed_id = param.embed_id;
			this.dom__refresh();
			this.fire('change')
		}
	}
	async __extractParametersFromUrl(url, expectedProvider) {
		url = url ? url.trim() : '';
		var reg = false;
		console.log(url);
		if (reg = url.match(/youtube:(?<id>[^?\/"]+)/)) {
			return { provider: 'youtube', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/youtube([^\/]*).com\/embed\/(?<id>[^?\/"]+)"/)) {
			return { provider: 'youtube', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/youtube\.com\/watch\?(.*&)?v=(?<id>[^&#]+)/)) {
			return { provider: 'youtube', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/youtu\.be\/(?<id>[^\/]+)/)) {
			return { provider: 'youtube', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/vimeo:(?<id>[^?\/]+)/)) {
			return { provider: 'vimeo', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/vimeo\.com\/channels\/[^\/]+\/(?<id>[^?\/]+)/)) {
			return { provider: 'vimeo', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/player\.vimeo\.com\/video\/(?<id>[^?\/"]+)"/)) {
			return { provider: 'vimeo', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/vimeo\.com\/video\/(?<id>[^?\/]+)/)) {
			return { provider: 'vimeo', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/vimeo\.com\/(?<id>[^\/]+)/)) {
			return { provider: 'vimeo', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/gumlet\.tv\/(?<id>[^?\/"]+)/)) {
			return { provider: 'gumlet', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/dashboard\.gumlet.com\/video\/manage\/asset\/(?<id>[^?\/"]+)/)) {
			return { provider: 'gumlet', embed_id: reg.groups.id };
		}
		else if (reg = url.match(/play\.gumlet\.io\/embed\/(?<id>[^?\/"]+)/)) {
			return { provider: 'gumlet', embed_id: reg.groups.id };
		}
		else if (url.match(/^[0-9A-Za-z_-]+$/i)) {
			return { provider: expectedProvider, embed_id: url };
		}
		return { provider: null, embed_id: null };
	}

}